<template>
  <div>
    <v-tabs grow v-model="tab" color="primary" class="hidden-lg-and-up">
      <v-tab class="white--text">État</v-tab>
      <v-tab class="white--text">
        <span v-if="notifsCount === 0">Suivi</span>
        <v-badge left color="red" v-else>
          <template v-slot:badge>
            <span>{{ notifsCount }}</span>
          </template>
          <span style="color: red; font-weight: bolder">Suivi</span>
        </v-badge>
      </v-tab>
      <v-tab class="white--text">Infos</v-tab>
      <v-tab class="white--text">Timeline</v-tab>
    </v-tabs>
    <v-container fluid>
      <v-card
        class="mx-2 my-2 px-2 py-2 mt-3 mb-5 font-weight-bold"
        style="background: #ff7c5d; color: white"
      >
        Home in love a crée le compagnon de la mobilité professionnelle pour
        s'occuper de toute la gestion personnelle qui en découle. Vous déménagez
        pour vous rapprocher de votre entreprise ou de votre centre de formation
        ! Nous sommes là pour vous aider : maturation du projet, recherche de
        logement, intégration dans la ville, branchement des fluides... en
        fonction de vos besoins, de vos disponibilités et de vos priorités, nous
        nous adaptons.<br /><br />

        NE CHERCHEZ PLUS, HOME IN LOVE TROUVE POUR VOUS<br /><br />

        L'aide Mobilipass ayant connue un très grand succès, sa distribution est
        presque clôturée. Home in Love continue son action sociale au service du
        logement des salariés/alternants. Un doute, une question, n’hésitez pas
        à nous contacter au
        <a href="tel:0033767382368" title="Contactez notre équipe support"
          >07 67 38 23 68</a
        >
        ou à
        <a
          href="mailto:assistance@homeinlove.fr"
          title="Écrivez à notre équipe support"
          >assistance@homeinlove.fr</a
        >
        pour être recontacté.
      </v-card>
      <v-layout row wrap>
        <v-flex xs12 lg3>
          <div class="title ml-2 mb-3 hidden-md-and-down">État du projet</div>
          <div v-if="signatures">
            <div
              v-for="signature in signatures"
              v-bind:key="signature.transactionId"
            >
              <v-btn
                class="signature-btn"
                v-if="!signed(signature)"
                @click="signDocument(signature)"
              >
                Vous devez signer des documents appartenant à l'étape
                {{
                  signatureSteps.find(step => step.value === signature.step)
                    .text
                }}.
              </v-btn>
            </div>
          </div>
          <ProjectState
            :class="{ 'hidden-md-and-down': tab !== 0 }"
            :id="projectId"
          />
        </v-flex>
        <v-flex xs12 lg3>
          <div class="title ml-3 mb-3 hidden-md-and-down">
            <span v-if="notifsCount === 0">Commentaires</span>

            <div v-else class="d-flex justify-space-between align-center mr-2">
              <div>
                <v-badge right color="red">
                  <template v-slot:badge>
                    <span>{{ notifsCount }}</span>
                  </template>
                  <span style="color: red; font-weight: bolder"
                    >Commentaires</span
                  >
                </v-badge>
              </div>
            </div>
          </div>
          <div class="mt-2 mx-3" :class="{ 'hidden-md-and-down': tab !== 1 }">
            <ProjectComments
              :id="projectId"
              :extra-attributes="{ visibility: 'all' }"
              :active="tab === 1 || $mq === 'lg'"
            />
          </div>
        </v-flex>
        <v-flex xs12 lg3>
          <div class="title ml-3 mb-3 hidden-md-and-down">
            Informations utiles
          </div>

          <div
            class="mt-2 mx-3 useful-docs"
            :class="{ 'hidden-md-and-down': tab !== 2 }"
          >
            <a
              class="mb-2"
              :href="`${baseURL}/useful/1. Assistance sur le lieu de départ/`"
              target="_blank"
              >Assistance sur le lieu de départ</a
            >

            <a
              class="mb-2"
              :href="`${baseURL}/useful/2. Assistance sur le lieu d'arrivée/`"
              target="_blank"
              >Assistance démarches administratives sur le lieu d'arrivée</a
            >

            <a
              class="mb-2"
              v-if="environmentLink"
              :href="environmentLink"
              target="_blank"
              >Présentation de la région et de la ville d'accueil</a
            >
            <a
              class="mb-2"
              href="https://www.actionlogement.fr/sites/als/files/documents/Fiches_produits/fiche_mon_job_mon_logt_juillet2022.pdf"
              target="_blank"
              >L'Aide Mon job Mon logement</a
            >
            <a
              class="mb-2"
              href="https://www.actionlogement.fr/sites/als/files/documents/Fiches_produits/fiche_aide_mobili_jeune_juill2022.pdf"
              target="_blank"
              >L'Aide Mobili-JEUNE</a
            >
            <a
              class="mb-2"
              href="https://www.actionlogement.fr/sites/als/files/documents/Fiches_produits/fiche_avance_loca_pass_juin2022.pdf"
              target="_blank"
              >L'avance Loca-PASS</a
            >
            <a
              class="mb-2"
              href="https://www.actionlogement.fr/sites/als/files/documents/Fiches_produits/fiche_visale_locataire_juin2021.pdf"
              target="_blank"
              >La Garantie VISALE</a
            >
            <a
              class="mb-2"
              href="https://www.actionlogement.fr/sites/als/files/documents/Fiches_produits/fiche_aide_mobili_pass_juin2022.pdf"
              target="_blank"
              >L'aide Mobili-PASS</a
            >
          </div>
        </v-flex>
        <v-flex xs12 lg3>
          <div class="title ml-3 mb-3 hidden-md-and-down">Timeline</div>

          <div class="mt-2 mx-3" :class="{ 'hidden-md-and-down': tab !== 3 }">
            <ProjectTimeline :id="projectId"></ProjectTimeline>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-flex></v-flex>
    <v-dialog
      :value="documentUrl"
      v-if="documentUrl !== null"
      width="100%"
      height="90%"
      top="5%"
      left="5%"
    >
      <v-card id="contralia-sign-document">
        <div style="overflow: scroll; -webkit-overflow-scrolling: touch">
          <iframe
            :src="documentUrl"
            title="Signer le document"
            width="100%"
            height="500px"
          ></iframe>
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showError" :timeout="7000"
      >Une erreur a eu lieu</v-snackbar
    >
  </div>
</template>
<script>
import ProjectTimeline from "../components/project/ProjectTimeline";
import ProjectComments from "../components/project/ProjectComments";
import ProjectState from "../components/project/ProjectState";
import { SIGNATURE_STEPS } from "../../../webapp-commons/data";
import { fetchHil } from "../utils";

export default {
  components: { ProjectComments, ProjectTimeline, ProjectState },
  data() {
    return {
      tab: 0,
      signatureSteps: SIGNATURE_STEPS,
      documentUrl: null,
      showError: false,
      baseURL: process.env.VUE_APP_BASEURL
    };
  },
  async mounted() {
    this.loadData();
  },
  computed: {
    projectId() {
      return this.$route.params.lease_id;
    },
    environmentLink() {
      if (
        this.$store.state.currentProject &&
        this.$store.state.currentProject.addressWorkObject &&
        typeof this.$store.state.currentProject.addressWorkObject.latitude ===
          "number" &&
        typeof this.$store.state.currentProject.addressWorkObject.longitude ===
          "number"
      ) {
        return `http://map.datafrance.info/education?coords.lat=${
          this.$store.state.currentProject.addressWorkObject.latitude
        }&coords.lng=${
          this.$store.state.currentProject.addressWorkObject.longitude
        }&zoom=14&d.d1.id=ecoles-elementaires&d.d1.gr=marker&d.d1.y=2014&d.d1.gp=appellation-officielle-de-l-uai&d.d1.f=secteur&d.d1.on=1&d.d1.slug=d1`;
      } else {
        return null;
      }
    },
    signatures() {
      return this.$store.state.currentProject
        ? this.$store.state.currentProject.signatures
        : [];
    },
    notifsCount() {
      return this.$store.state.notifications.filter(
        ({ idEstate, idProject, seen }) =>
          idEstate == null && idProject === this.projectId && !seen
      ).length;
    }
  },
  methods: {
    async loadData() {
      await this.$store.dispatch("fetchProject", {
        id: this.projectId
      });
    },
    markNotifsAsRead() {
      this.$store.dispatch("markNotifsAsRead", { projectId: this.projectId });
    },
    async signDocument(signature) {
      const signatory = signature.signatories.find(
        signatory => !signatory.isCo
      );

      let resp;
      try {
        resp = await fetchHil(
          `/signatures/${this.projectId}/${signature.transactionId}/${
            signatory.id
          }`,
          { method: "GET" }
        );
      } catch (e) {
        console.log(e);
      }

      if (!resp || !resp.ok) {
        this.showError = true;
        return;
      }

      const result = await resp.json();

      if (result.url) {
        this.documentUrl = result.url;
      }
    },
    signed(transaction) {
      if (this.$store.state.currentProject) {
        const signatory = transaction.signatories.find(
          signatory =>
            signatory.email === this.$store.state.currentProject.userId
        );
        return signatory ? signatory.signed : false;
      }
      return false;
    }
  }
};
</script>

<style>
.signature-btn {
  max-width: 100%;
  min-height: 36px;
  height: auto;
}
.signature-btn .v-btn__content {
  width: 100%;
  height: 100%;
  padding: 10px 16px;
  white-space: normal;
}
.useful-docs a {
  display: block;
}
</style>
